export const api = {
    sendEmailFeedback: (token: string): string => `/api/email_feedback/${token}/`
};
